<template>
  <div class="container">
    <slot />
  </div>
</template>

<style lang="less" scoped>
.container {
  background: #fff;
  position: relative;
  top: 80px;
  height: calc(100vh - 80px);
  margin: 0 auto;
  padding-top: 10px;
  z-index: 1;
}
</style>
